import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import { type ServiceOptionsRequest } from '@service-initiation/shared-clients-tech-care-services';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { techCareServicesClient } from './clients/techCareServicesClient';

export const GET_SERVICE_OPTIONS_CACHE_KEY = 'serviceOptions';

export const getServiceOptions = async (request: ServiceOptionsRequest) => {
  try {
    return await queryClient.fetchQuery({
      queryFn: async () => {
        const response = await techCareServicesClient.getServiceOptions(
          request
        );

        if (response.status !== HttpStatusCodes.OK) {
          throw new Error('Received invalid response status from server.');
        }

        if (response.body?.error) {
          throw new Error('Failed to fetch service options');
        }

        return response.body;
      },
      queryKey: [GET_SERVICE_OPTIONS_CACHE_KEY, request],
      retry: 2,
      staleTime: Infinity,
    });
  } catch (err) {
    const error = err as Error;
    logger.error(error, {
      data: request,
    });
    throw error;
  }
};
